/**
 * @generated SignedSource<<5260673e7b49f18bba0b28122ce4ee09>>
 * @relayHash 0e295bd8cf5556f9a2ed20c4e7811231
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3363969b24a2c14b0a0a295feb9e9c205423d0ccd5685c2eaf9083dda1987721

import type { ConcreteRequest, Query } from 'relay-runtime';
export type eligibilityUserCanUpgradeQuery$variables = {
  cloudId: string;
  offeringKey?: string | null | undefined;
  productKey: string;
};
export type eligibilityUserCanUpgradeQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly changeOffering: {
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type eligibilityUserCanUpgradeQuery = {
  response: eligibilityUserCanUpgradeQuery$data;
  variables: eligibilityUserCanUpgradeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offeringKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v3 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "offeringKey",
    "variableName": "offeringKey"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "eligibilityUserCanUpgradeQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v5/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOffering",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "eligibilityUserCanUpgradeQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "args": (v5/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOffering",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3363969b24a2c14b0a0a295feb9e9c205423d0ccd5685c2eaf9083dda1987721",
    "metadata": {},
    "name": "eligibilityUserCanUpgradeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bfb3759dfd2863e60432f4c195d1030a";

export default node;
